import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  infoPaper: {
    minHeight: 86,
    maxHeight: 86,
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "14px 16px",
    position: "relative",
    overflow: "hidden",
    flexWrap: "nowrap",
    flex: "auto",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  clickable: {
    cursor: "pointer"
  },
  corner: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
    width: 18,
    height: 18,
    "&:after": {
      zIndex: 0,
      content: "''",
      position: "absolute",
      top: 0,
      right: 0,
      borderColor: "transparent",
      borderStyle: "solid",
      borderWidth: 18,
      borderRightColor: "#f6f6f6",
      borderTopColor: "#f6f6f6"
    }
  },
  cornerIcon: {
    zIndex: 1,
    fontSize: 13,
    color: "#7d7d7d"
  },
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 42,
    minHeight: 42,
    width: 42,
    height: 42,
    color: "#51c69e",
    backgroundColor: "rgba(97, 198, 158, 0.15)",
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "50%",
    marginRight: 16,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      zIndex: 0,
      width: 145,
      height: 145,
      left: -30,
      top: -26,
      marginRight: 0,
      opacity: "0.08",
      border: `1px solid ${theme.palette.secondary.dark}`,
      backgroundColor: "rgba(97, 198, 158, 0.15)",
      boxSizing: "border-box",
      textAlign: "center",
      lineHeight: "normal"
    }
  },
  badgeIcon: {
    width: 26,
    [theme.breakpoints.down("xs")]: {
      fontSize: 80,
      width: 80
    }
  },
  horsesOnListsBadge: {
    border: `1px solid ${theme.palette.warning.main}`,
    backgroundColor: "rgba(216, 47, 68, 0.15)",
    color: theme.palette.warning.dark,
    [theme.breakpoints.down("xs")]: {
      opacity: 0.05
    }
  },
  count: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 22,
    lineHeight: "normal",
    [theme.breakpoints.down("xs")]: {
      height: 38,
      zIndex: 10,
      fontSize: 36,
      flexBasis: "auto",
      marginBlockStart: 0,
      marginBlockEnd: 0
    }
  },
  label: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 12,
    lineHeight: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
      zIndex: 10
    }
  },
  listsModal: {
    "& .MuiDialog-paper": {
      maxWidth: 351,
      width: "100%"
    },
    "& .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20,
      "& .MuiTypography-root": {
        fontSize: 18,
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        lineHeight: "23px"
      }
    },
    "& .MuiDialogContent-root": {
      padding: 0
    },
    "& .MuiDialogContent-dividers": {
      borderTop: `1px solid ${theme.palette.text.hint}`
    },
    "& .MuiTableRow-root:nth-child(2n) .MuiTableCell-root": {
      backgroundColor: "transparent"
    }
  },
  listTableRow: {
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    "&:nth-child(odd)": {
      backgroundColor: "rgba(238, 238, 238, 0.5)"
    },
    "&:last-child": {
      borderBottom: "none"
    }
  },
  contentRows: {
    borderBottom: "1px solid #eee",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  listsTableCell: {
    minHeight: 47,
    padding: "13px 8px 13px 8px"
  },
  listsTableCellName: {
    verticalAlign: "top",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    padding: "13px 8px 13px 20px",
    wordBreak: "break-word"
  },
  listsTableCellDate: {
    padding: "13px 20px 13px 8px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  dialogLoader: {
    minHeight: 120
  }
}));
